/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./EventGroupActions',
	'../../../../app/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'underscore'
], function(EventGroupActions, stringResources, ContentActionsProviderAPI, _) {

	class DisconnectEventGroupAction extends EventGroupActions {
		constructor({ features }) {
			super({ features: features });
			features.ContentActions.registerProvider('disconnectFilterGroup', this.getAPI());
		}

		getContentActionList(idList) {
			if(this._isAvailable(idList)) {
				return [{
					name: 'disconnectFilterGroup',
					label: stringResources.get('toolbarActionDisconnectFilterGroup'),
					icon: this._features['Icons'].getIcon('unlink').id,
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.DASHBOARD,
					order: 40,
					actions: {
						apply: this.execute.bind(this, idList)
					},
					disabled: this.isDisabled.bind(this, idList),
					update: true
				}];
			} else {
				return [];
			}
		}

		execute(idList) {
			this._features['EventGroups'].removeFromGroup(idList);
		}

		isDisabled(idList){
			if (this._isStaticWidget(idList)) {
				return true;
			}
			let groups = this._features['EventGroups'].getGroupIdsOnPage(this._getPageId(idList));
			if (groups.length <= 0) {
				// disable if no groups on page
				return true;
			}

			let count = this._getCountGroupsAffected(idList);
			//if the number of groups remaining after disconnecting will be greater than 5, it should be disabled
			if(this.getNumberOfGroups(idList) + idList.length - count > 5){
				return true;
			}

			//also if the selection contains only groups that have a single widget, it should be disabled
			let selectedGroupsWithMoreThanOneWidget = _.filter(idList, id => {
				let groupId = this._features['EventGroups'].getGroupId(id);
				return this._features['EventGroups'].getContentIdList(groupId).length>1;
			});
			if (selectedGroupsWithMoreThanOneWidget.length===0){
				return true;
			}
			return false;
		}
	}

	return DisconnectEventGroupAction;
});
